import { platformService } from '@monthio/react-components'
import { statisticsReportApi } from './apis'

export interface ClientTelemetryDto {
	eventName: string
	additionalData: any
}

export const sendMixpanelTelemetry = async (body: any = {}) => {
	try {
		const token = platformService.getAccessToken()
		await statisticsReportApi
			.keepAlive()
			.silentFail()
			.postRaw(`client-telemetry/flow${token == null ? '-anonymous' : ''}`, {
				body: JSON.stringify(body),
			})
			.text()
	} catch (error: any) {
		if (error.response?.status === 401) {
			statisticsReportApi
				.keepAlive()
				.silentFail()
				.postRaw(`client-telemetry/flow-anonymous`, {
					body: JSON.stringify(body),
				})
				.text()
				.catch(console.error)
		}
		console.error(error)
	}
}

export const sendTelemetry = async (body: ClientTelemetryDto) => {
	try {
		const token = platformService.getAccessToken()
		await statisticsReportApi
			.keepAlive()
			.silentFail()
			.post(
				`client-telemetry/all/flow${token == null ? '-anonymous' : ''}`,
				body,
			)
	} catch (error: any) {
		if (error.response?.status === 401) {
			statisticsReportApi
				.keepAlive()
				.silentFail()
				.post(`client-telemetry/all/flow-anonymous`, body)
				.catch(console.error)
		}
		console.error(error)
	}
}
